import { AnimationEvent } from '@angular/animations';

import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PageTitleDirective } from '@directives/page-title/page-title.directive';
import { Notification } from '@models/notifications.model';
import { ActivityStateService } from '@services/activity/state/activity-state.service';
import { NotificationsService } from '@services/notifications/notifications.service';
import { OfoIndicatorComponent } from '@shared-components/ofo-indicator/ofo-indicator.component';
import { ProgressBarComponent } from '@shared-components/progress-bar/progress-bar.component';
import { routerAnimation } from '@shared/animations/router.animations';
import { Subscription } from 'rxjs';
import { NotificationsComponent, ViewService } from 'tangoe-design-system';

@Component({
  selector: 'ts-shopping-layout',
  templateUrl: './layout.component.html',
  animations: [routerAnimation],
  imports: [
    PageTitleDirective,
    RouterOutlet,
    ProgressBarComponent,
    OfoIndicatorComponent,
    NotificationsComponent
  ]
})
export class LayoutComponent implements OnInit, OnDestroy {
  navigation_title: string = '';
  page_title: string = '';
  order_type_id: number;
  storage_key: string;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private activity_state_svc: ActivityStateService,
    private cdref: ChangeDetectorRef,
    private notifications_svc: NotificationsService,
    private view_svc: ViewService
  ) {}

  ngOnInit(): void {
    this.order_type_id = this.activity_state_svc.orderTypeId();
    this.storage_key = `${NotificationsService.ORDER_NOTIFICATIONS_STORAGE_KEY}-${this.order_type_id}`;
    this.navigation_title = this.activity_state_svc.activityCategoryName();
    this.page_title = this.activity_state_svc.activityName();

    if (this.order_type_id) {
      this.subscriptions.add(
        this.notifications_svc.orderNotifications(
          this.order_type_id,
          this.storage_key,
          this.replacement_user_id
        )
      );
    }

    this.cdref.detectChanges();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  get order_notifications(): Notification[] {
    return this.notifications_svc.order_notifications.value;
  }

  get replacement_user_id(): number | undefined {
    return this.activity_state_svc.parameter('replacement_person')?.id;
  }

  onRouterAnimationStart(event: AnimationEvent): void {
    this.view_svc.resetScrollPosition();
  }

  markNotificationAsRead(event: { notification: Notification; type: string }): void {
    this.notifications_svc.markAsRead(event.notification, event.type);
  }
}
